<template>
    <div class="container py-5">
      <h2>About Us</h2>
      <p>Learn more about our mission to help people on their recovery journey.</p>
    </div>
  </template>
  